import script from "./PlanSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanSelector.vue?vue&type=script&setup=true&lang=js"

import "./PlanSelector.vue?vue&type=style&index=0&id=0a31913c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a31913c"]])

export default __exports__